import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BrandService } from "./brand.service";

const initialState = {
  brands: [],
  brand: null,
  success: false,
  isLoading: false,
  error: null,
  message: null,
};

export const addBrand = createAsyncThunk(
  "brand/addBrand",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _brandService = new BrandService();
      const response = await _brandService.addBrand(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBrands = createAsyncThunk(
  "brand/getBrands",
  async (_, { rejectWithValue, getState }) => {
    try {
      const _brandService = new BrandService();
      const response = await _brandService.getBrands();
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getBrand = createAsyncThunk(
  "brand/getBrand",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _brandService = new BrandService();
      const response = await _brandService.getBrand(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateBrand = createAsyncThunk(
  "brand/updateBrand",
  async (data, { rejectWithValue, getState }) => {
    try {
      const _brandService = new BrandService();
      const response = await _brandService.updateBrand(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteBrand = createAsyncThunk(
  "brand/deleteBrand",
  async (id, { rejectWithValue, getState }) => {
    try {
      const _brandService = new BrandService();
      const response = await _brandService.deleteBrand(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    reset: (state) => {
      state.success = false;
      state.isLoading = false;
      state.error = null;
      state.message = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(addBrand.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(addBrand.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.brand = action.payload?.data;
      state.message = action.payload?.message || "Brand created successfully";
    });
    builder.addCase(addBrand.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to add brand";
    });

    builder.addCase(getBrands.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBrands.fulfilled, (state, action) => {
      state.isLoading = false;
      const payload = action.payload?.data;
      state.brands = Array.isArray(payload) ? payload : [];
    });
    builder.addCase(getBrands.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload?.message || "Failed to load brands";
    });

    builder.addCase(getBrand.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBrand.fulfilled, (state, action) => {
      state.isLoading = false;
      state.brand = action.payload?.data;
    });
    builder.addCase(getBrand.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to get brand";
    });

    builder.addCase(updateBrand.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(updateBrand.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.brand = action.payload?.data;
      state.message = action.payload?.message || "Brand updated successfully";
    });
    builder.addCase(updateBrand.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to update brand";
    });

    builder.addCase(deleteBrand.pending, (state) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    });
    builder.addCase(deleteBrand.fulfilled, (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.message = action.payload?.message || "Brand deleted successfully";
    });
    builder.addCase(deleteBrand.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload || "Failed to delete brand";
    });
  },
});

export const { reset } = brandSlice.actions;
export default brandSlice.reducer;
